module.exports = __webpack_public_path__ + "static/media/ClassicSimpleOrgChartCardImage.a5ad82d3.png";